export const errorMessages: { [code: string]: string } = {
  'app/unknown-error':
    "Navré, une erreur inattendue gêne l'application. Vous pouvez essayer de relancer l'application. \n" +
    "Prévenez le développeur si l'erreur persiste.",
  'app/network-error': 'Le service est indisponible pour le moment. Réessayez plus tard.',
  'app/session-expired': 'Votre session a expirée.',
  problems: "L'application a rencontré des difficultés. Réessayez plus tard et prévenez-nous si le problème persiste.",
};
